import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import ProtectedLayout from "~/app/layouts/LoggedIn";
import LoginLayout from "~/app/layouts/Login";
import SharedLayout from "~/app/layouts/Shared";

import Loader from "~/app/components/Loader";

import { useVerifyAuthenticationQuery } from "~/app/data/a12nHooks";
import {
  useAppConfigQuery,
  usePublicConfigurationQuery,
} from "~/app/data/appDataHooks";

import { ROUTE_LOGIN } from "~/app/constant/routes";

export default function MainRouter() {
  const location = useLocation();

  // List of public routes (authorized without verified access)
  const loginRoutes = [ROUTE_LOGIN];

  // List of shared routes (authorized without verified access)
  const sharedRoutes = [];

  // All public routes (login + shared)
  const publicRoutes = [...loginRoutes, ...sharedRoutes];

  // Boolean defining if the authorization needs to be verified (only if the requested pathname is not a public route)
  const enableVerify = !publicRoutes.find(
    (route) => location.pathname.indexOf(route) === 0
  );

  // Query to verify authentication.
  // isAuthenticated should return a boolean
  const { data: isAuthenticated, isLoading: verifyAuthenticationLoading } =
    useVerifyAuthenticationQuery(enableVerify);

  const { isPending: appConfigLoading } = useAppConfigQuery();
  const { isPending: publicConfigLoading } = usePublicConfigurationQuery();

  if (appConfigLoading || publicConfigLoading || verifyAuthenticationLoading) {
    return <Loader size="large" type="absolute" />;
  }
  return (
    <>
      <Switch>
        <Route path={loginRoutes} component={LoginLayout} />
        <Route path={sharedRoutes} component={SharedLayout} />
        {isAuthenticated && <Route component={ProtectedLayout} />}
        <Redirect
          to={{
            pathname: ROUTE_LOGIN,
            state: { from: location },
          }}
        />
      </Switch>
    </>
  );
}
